import '../PlanCard.scss';

import { Resource } from '@travelwin/core/src/interfaces';
import classNames from 'classnames';
import { startOfToday, parseISO, isBefore, isEqual, isAfter } from 'date-fns';
import { useTranslation } from 'react-i18next';

const className = 'c-PlanCard';

type FeaturedLabelProps = {
  text: string | null;
  textFrom: string | null;
  textTo: string | null;
  featuredStyle: Resource | null;
};

const FeaturedLabel = ({
  text,
  textFrom,
  textTo,
  featuredStyle,
}: FeaturedLabelProps) => {
  const { t } = useTranslation();

  const defaultFeaturedText = t(
    'ecommerce:plan_title.top_seller',
    'Top Seller',
  );

  const label = () => {
    if (text) {
      const today = startOfToday();
      const fromDate = textFrom ? parseISO(textFrom) : undefined;
      const toDate = textTo ? parseISO(textTo) : undefined;

      const isFromDateValid = fromDate
        ? isBefore(fromDate, today) || isEqual(fromDate, today)
        : true;
      const isToDateValid = toDate
        ? isAfter(toDate, today) || isEqual(toDate, today)
        : true;

      if (isFromDateValid && isToDateValid) {
        return text;
      }

      return defaultFeaturedText;
    } else {
      return defaultFeaturedText;
    }
  };
  return (
    <div
      className={classNames(`${className}__label`, {
        [`${className}__label--${featuredStyle?.id.toLowerCase()}`]:
          featuredStyle,
        style_1: !featuredStyle,
      })}
    >
      <p
        className={classNames(`${className}__label-text`, {
          [`${className}__label-text--${featuredStyle?.id.toLowerCase()}`]:
            featuredStyle,
          style_1: !featuredStyle,
        })}
      >
        {label()}
      </p>
    </div>
  );
};

export default FeaturedLabel;
